export class regenerationRequest {
    constructor(sales_list_id, locale) {
        this.sales_list_detail_ids = [];
        this.sales_list_id = sales_list_id;
        this.locale = locale;
    }
}